import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  FormLabel,
  Input,
  Text,
  Heading,
  Divider,
  Checkbox,
  CloseButton,
} from "@chakra-ui/react";
import { toast } from "react-toastify"; 

function CompetitiveRegisterForm({ dispatch, userRegister, navigate, onClose }) {
  // Local States
  const [userType, setUserType] = useState("client");
  const [isSignUp, setIsSignUp] = useState(true);
  const [formData, setFormData] = useState({
    full_name: "",
    designation: "",
    organization: "",
    addressLine1: "",
    addressLine2: "",
    pincode: "",
    products: [],
  });
  const [dataError, setDataError] = useState({});
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [loading, setLoading] = useState(false);

  // Example: Replace with your real data
  const selectedSectorCategory = null;

  // Generic input change handler
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Form submit handler
  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (formData.full_name === "") {
      toast.error("Please enter your full name");
    } else if (formData.designation === "") {
      toast.error("Please enter your designation");
    } else if (!termsAccepted) {
      toast.error("Please accept the Terms of Service to proceed");
    } else {
      console.log("User selected products:", formData.products);

      dispatch(
        userRegister(
          {
            full_name: formData.full_name,
            designation: formData.designation,
            companyName: formData.organization,
            companyAddressLine1: formData.addressLine1,
            companyAddressLine2: formData.addressLine2,
            companyPincode: formData.pincode,
            userType,
            sectorCategory: selectedSectorCategory,
            products: formData.products,
          },
          navigate
        )
      );
    }
  };

  return (
    <Box
      w="100%"
      maxH="110vh"
      overflowY="auto"
      bg="#FFFFFF"
      p={4}
      pb={20}
      borderRadius={10}
      position="relative"
    >
      {/* Close Button */}
      <CloseButton
        position="absolute"
        top="10px"
        right="10px"
        onClick={onClose} // 
      />
     


      <Text fontSize="18px" p={5} fontWeight="700" mr={3} color={"#5D5D5D"}>
        Rich insights await you
      </Text>

      {/* User Type Selection */}
      <Box
        display="flex"
        alignItems="center"
        flexDirection={{ base: "column", md: "row" }}
        mb={4}
      >
        <Text fontSize="16px" fontWeight="600" mr={3}>
          Are you a
        </Text>
        <Box display="flex">
          {["client", "agency", "expert"].map((type, i) => (
            <Box
              key={type}
              textAlign="center"
              px={4}
              py={2}
              cursor={isSignUp ? "pointer" : "not-allowed"}
              fontSize="14px"
              border="1px solid #0C543C"
              borderRadius={
                i === 0 ? "8px 0 0 8px" : i === 2 ? "0 8px 8px 0" : "0"
              }
              bg={userType === type ? "#0C543C" : "#fff"}
              color={userType === type ? "#fff" : "#0C543C"}
              onClick={() => isSignUp && setUserType(type)}
            >
              {type === "client"
                ? "SME"
                : type === "agency"
                ? "Practice"
                : "Expert"}
            </Box>
          ))}
        </Box>
      </Box>

      {/* Form Starts */}
      <Box w="100%">
        <Heading size="md" mb={3}>
          Your Account Details
        </Heading>

        {/* Full Name */}
        <Box mb={4}>
          <FormLabel>Your name</FormLabel>
          <Input
            name="full_name"
            value={formData.full_name}
            placeholder="Your Full Name"
            onChange={changeHandler}
            isInvalid={dataError.full_name}
            errorBorderColor="red.500"
          />
        </Box>

        {/* Designation */}
        <Box mb={4}>
          <FormLabel>Your designation</FormLabel>
          <Input
            name="designation"
            value={formData.designation}
            placeholder="Your designation"
            onChange={changeHandler}
            isInvalid={dataError.designation}
            errorBorderColor="red.500"
          />
        </Box>

        <Divider my={4} />

        {/* Organization */}
        <Heading size="sm" mb={3}>
          Your Organization
        </Heading>
        <Box mb={4}>
          <FormLabel>Organization name</FormLabel>
          <Input
            name="organization"
            value={formData.organization}
            placeholder="Organization name"
            onChange={changeHandler}
            isInvalid={dataError.organization}
            errorBorderColor="red.500"
          />
        </Box>

        {/* Address */}
        <Box mb={4}>
          <FormLabel>Address Line 1</FormLabel>
          <Input
            name="addressLine1"
            value={formData.addressLine1}
            placeholder="Address Line 1"
            onChange={changeHandler}
            isInvalid={dataError.addressLine1}
            errorBorderColor="red.500"
          />
        </Box>
        <Box mb={4}>
          <FormLabel>Address Line 2</FormLabel>
          <Input
            name="addressLine2"
            value={formData.addressLine2}
            placeholder="Address Line 2"
            onChange={changeHandler}
            isInvalid={dataError.addressLine2}
            errorBorderColor="red.500"
          />
        </Box>

        {/* Pincode */}
        <Box mb={4}>
          <FormLabel>Pincode</FormLabel>
          <Input
            name="pincode"
            value={formData.pincode}
            placeholder="Enter Pincode"
            onChange={changeHandler}
            isInvalid={dataError.pincode}
            errorBorderColor="red.500"
          />
        </Box>

        {/* Terms */}
        <Flex mb={4}>
          <Checkbox
            colorScheme="green"
            isChecked={termsAccepted}
            onChange={() => setTermsAccepted(!termsAccepted)}
          />
          <Text pl={2}>
            I agree to the{" "}
            <a
              href="https://merchant.razorpay.com/policy/M9LEThfaHp4VWn/terms"
              style={{ textDecoration: "underline" }}
            >
              Terms of Service
            </a>
          </Text>
        </Flex>

        {/* Buttons */}
        <Box textAlign="center">
          <Button
            bg="#0C543C"
            color="white"
            mr={4}
            onClick={() => setIsSignUp(true)}
          >
            Back
          </Button>
          <Button
            bg="#0C543C"
            color="white"
            onClick={handleFormSubmit}
            isLoading={loading}
          >
            Sign Up
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default CompetitiveRegisterForm;
